import { render, staticRenderFns } from "./DirectPay.vue?vue&type=template&id=2f6cd6ea&scoped=true&"
import script from "./DirectPay.vue?vue&type=script&lang=js&"
export * from "./DirectPay.vue?vue&type=script&lang=js&"
import style0 from "./DirectPay.vue?vue&type=style&index=0&id=2f6cd6ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6cd6ea",
  null
  
)

export default component.exports